module.exports = __webpack_public_path__ + "static/img/vega.b00ad43.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/personas/vega.jpg
// module id = 511
// module chunks = 11